export default {
  default: () => import("/home/runner/work/getgrain/getgrain/packages/app/app/layouts/default.vue").then(m => m.default || m)
}